// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_2EeHR","container":"index_container_6Bu6v","footerNav":"index_footerNav_3M0wu"};